import React from "react";
import DeleteSVG from "../../../components/svg/DeleteSVG";
import EditSVG from "../../../components/svg/EditSVG";

export default function VideosListTr({ row, handleDeleteVideo }) {
  const { id, title, description } = row || {};
  return (
    <>
      <tr>
        <td className="table-td">{title}</td>
        <td className="table-td ellipses max-w-[300px]" title={description}>
          {description}
        </td>
        <td className="table-td flex gap-x-2">
          <DeleteSVG onClick={() => handleDeleteVideo(id)} />
          <EditSVG to={`/admin/editVideo/${id}`} />
        </td>
      </tr>
    </>
  );
}
